module.exports = __webpack_public_path__ + "img/Monte_Kope_28.024a7dfa.jpg";